/**
 * @author Hiroki Moto
 */

import React from 'react';
import classNames from 'classnames';
import Avatar from '@components/@core/Avatar';
import Rating from '@components/@core/Rating';

const PopularProduct = ({ className, logo, title, score, recommendation, onClick, isSponsored }) => (
    <div className={classNames('popular-product', className)} onClick={onClick}>
        <Avatar type="logo" size="large" name={title} url={logo || '/images/default_company.svg'} borderColor="#e0e0e0" borderWidth={2} isSponsored={isSponsored} />
        <p className="dsl-b16 bold text-center mt-3 mb-2 word-break">{title}</p>
        <div className="d-flex justify-content-between mb-2">
            <Rating score={score} />
        </div>
        <p className="dsl-m14 text-center mb-0">{recommendation}% Recommended</p>
    </div>
);

export default PopularProduct;
